module.exports = __webpack_public_path__ + "static/img/legend_xg_english.1064277.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/legend_xg_english.png
// module id = Hec4
// module chunks = 94